import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const NPIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="NP" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path fill="#fff" d="M0 0h16v12H0z" />
      <Path
        fill="#C51918"
        stroke="#4857A1"
        strokeWidth={0.8}
        d="M9.6 5.692H5.139l.556.659 4.444 5.249H.4V.78l9.2 4.911Z"
      />
      <Mask
        id="b"
        width={12}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.8}
          d="M9.6 5.692H5.139l.556.659 4.444 5.249H.4V.78l9.2 4.911Z"
        />
      </Mask>
      <G fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
        <Path
          fill="#F7FCFF"
          d="m2.915 10.036-.613.782-.028-.987-.963.278.567-.815-.946-.332.946-.332-.567-.815.963.279.028-.988.613.782.612-.782.029.988.963-.28-.567.816.945.332-.945.332.567.815-.963-.278-.029.987-.612-.782ZM2.9 4.191l-.32.41-.015-.517-.503.146.296-.426-.493-.173.493-.174-.296-.426.503.146.015-.516.32.409.32-.409.015.516.503-.146-.296.426.493.174-.493.173.296.426-.503-.146-.015.516-.32-.409Z"
        />
        <Path
          fill="#F9FAFA"
          d="M2.833 4.071c1.096.005 1.68-.627 1.68-.627.116.72-.777 1.2-1.67 1.2-.893 0-1.433-.653-1.766-1.2 0 0 .66.623 1.756.627Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
